<template>
  <div>
    <div id="_login_container">

    </div>
  </div>
</template>

<script>
import bookingService from "@/apis/booking/index.js";
import { setStorageExpire } from "@/utils/utils";

export default {
  data() {
    return {
      originUrl: "",
    };
  },
  created() {
    if (this.$route.query.code) {
      this.getInfo();
    }
  },
  mounted() {
    // 去除url中的code、state参数
    let url = window.location.href;
    let index = url.indexOf("code");
    if (index != -1) {
      url = url.substring(0, index - 1);
    }
    index = url.indexOf("state");
    if (index != -1) {
      url = url.substring(0, index - 1);
    }
    this.originUrl = url;

    var handleMessage = function (event) {
      var origin = event.origin;
      console.log("origin", event.origin);
      if (origin == "https://login.dingtalk.com") {
        //判断是否来自ddLogin扫码事件。
        var loginTmpCode = event.data;
        //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingbh0pm0xk4gscxahb&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${encodeURIComponent(
          this.originUrl
        )}&loginTmpCode=${loginTmpCode}`;
        console.log("loginTmpCode", loginTmpCode);
      }
    };
    if (typeof window.addEventListener != "undefined") {
      window.addEventListener("message", handleMessage, false);
    } else if (typeof window.attachEvent != "undefined") {
      window.attachEvent("onmessage", handleMessage);
    }
    this.init();
  },
  methods: {
    getInfo() {
      const params = {
        code: this.$route.query.code,
        key: "8C04147B94984ADA913BF894538DFF78",
      };
      bookingService
        .getUserIdByCode(params)
        .then((res) => {
          //            res = {
          //     "status": true,
          //     "message": "",
          //     "user_id": "195850221221493570"
          // }
          if (res.user_id) {
            setStorageExpire("dd-user-id", res.user_id, 60 * 24 * 7);
            if (this.$route.params.redirect) {
              this.$router.push(
                decodeURIComponent(this.$route.params.redirect)
              );
            } else {
              this.$router.push("/");
            }
          }
        })
        .catch(() => {});
    },
    init() {
      const url = encodeURIComponent(this.originUrl);

      const goto = encodeURIComponent(
        `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingbh0pm0xk4gscxahb&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${url}`
      );
      /* eslint-disable */
      var obj = DDLogin({
        id: "_login_container", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
        goto, //请参考注释里的方式
        style: "border:none;background-color:#FFFFFF;",
        width: "365",
        height: "400",
      });
    },
  },
};
</script>

<style>
</style>